import React, { useContext, useEffect, useState } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import { getToken } from "../../utils/auth";
import LiquidacionesRegistradas from "./LiquidacionesRegistradas";
import ProcesamientoSas from "./ProcesamientoSas";
import { pagosApi } from "./pagosApi";
import "./pagos.css";

/**
 * Entrada única para la demo de Pagos. El flujo operativo vive en ProcesamientoSas:
 * selección → reconstrucción SQL → controles → registro aislado. La consulta heredada que
 * volvía a pedir un FUR Excel se retiró de esta pantalla para evitar caminos contradictorios.
 */
export default function Pagos() {
  const { darkMode } = useContext(DarkModeContext);
  const token = getToken();
  const [persistencia, setPersistencia] = useState(null);
  const [registros, setRegistros] = useState(0);

  useEffect(() => {
    let vigente = true;
    Promise.resolve().then(() => pagosApi.estadoLiquidaciones(token))
      .then((estado) => { if (vigente) setPersistencia(estado || { habilitada: false }); })
      .catch((error) => {
        if (vigente) setPersistencia({ habilitada: false, motivo: error?.message || "Persistencia no disponible." });
      });
    return () => { vigente = false; };
  }, [token]);

  return (
    <main className={`pagos-page${darkMode ? " pagos-page--dark" : ""}`} data-testid="pagos-page">
      <header className="pagos-header">
        <div>
          <p className="pagos-eyebrow">Pagos a comercios</p>
          <h1>Preparación y revisión del lote</h1>
          <p className="pagos-subtitle">Flujo de demostración con datos reales. No genera pagos, archivos bancarios ni cambios de estado.</p>
        </div>
        <div className="pagos-header-badges">
          <span className="pagos-mode-badge">Simulación · solo lectura productiva</span>
          <span className="pagos-status pagos-status--warning">Motor autónomo no validado</span>
        </div>
      </header>

      <div className="pagos-alert pagos-alert--info" role="note">
        <strong>Ruta única para la demo:</strong> seleccioná la fecha y procesá la importación SAS sugerida. El sistema reconstruye el FUR y ejecuta los controles sin solicitar el Reporte Excel.
      </div>

      <ProcesamientoSas token={token} persistencia={persistencia}
        onRegistered={() => setRegistros((value) => value + 1)} />

      <LiquidacionesRegistradas token={token} persistencia={persistencia} refreshKey={registros} />
    </main>
  );
}
